import { jsx as n, jsxs as b, Fragment as g } from "react/jsx-runtime";
import _, { forwardRef as y, useId as p, isValidElement as f, cloneElement as v } from "react";
import { c as o } from "./clsx-OuTLNxxd.js";
import { a as u } from "./Tooltip-CPBV-bV3.js";
import './Table.css';const W = "320px", H = "600px", z = "1025px", w = "_tableGroup_16vn8_32", C = "_table_16vn8_32", S = "_tableLabel_16vn8_46", B = "_tableWrapper_16vn8_64", T = "_tableCaption_16vn8_82", N = "_tableRow_16vn8_99", R = "_tableHeader_16vn8_103", F = "_tableColumn_16vn8_103", D = "_tableBody_16vn8_113", G = "_tableCell_16vn8_113", I = "_tableFooter_16vn8_115", j = "_highlight_16vn8_135", k = "_showDividers_16vn8_169", L = "_cellWrapper_16vn8_205", $ = "_headingText_16vn8_132", E = "_columnWrapper_16vn8_208", e = {
  "heading-l": "--cxy-fontSize-xxxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-extraBold",
  "heading-l-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-extraBold",
  "heading-m": "--cxy-fontSize-xxxl, --cxy-lineHeight-xxl, --cxy-fontWeight-semiBold",
  "heading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-semiBold",
  "heading-s": "--cxy-fontSize-xxl, --cxy-lineHeight-xl, --cxy-fontWeight-extraBold",
  "subHeading-l": "--cxy-fontSize-xl, --cxy-lineHeight-l, --cxy-fontWeight-bold",
  "subHeading-m": "--cxy-fontSize-l, --cxy-lineHeight-xs, --cxy-fontWeight-normal",
  "subHeading-m-mobile": "--cxy-fontSize-l, --cxy-lineHeight-l, --cxy-fontWeight-light",
  "subHeading-s": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "subHeading-s-mobile": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "button-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "button-s": "--cxy-fontSize-s, --cxy-lineHeight-xs, --cxy-fontWeight-semiBold",
  "button-xs": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "button-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxs, --cxy-fontWeight-semiBold",
  "text-m": "--cxy-fontSize-m, --cxy-lineHeight-s, --cxy-fontWeight-semiBold",
  "text-s": "--cxy-fontSize-s, --cxy-lineHeight-xxs, --cxy-fontWeight-normal",
  "text-xs": "--cxy-fontSize-xs, --cxy-lineHeight-m, --cxy-fontWeight-semiBold",
  "text-xxs": "--cxy-fontSize-xs, --cxy-lineHeight-xxxs, --cxy-fontWeight-normal",
  mobile: W,
  "mobile-wide": "480px",
  tablet: H,
  "tablet-wide": "800px",
  desktop: z,
  "desktop-mid": "1281px",
  "desktop-large": "1360px",
  tableGroup: w,
  table: C,
  tableLabel: S,
  tableWrapper: B,
  tableCaption: T,
  tableRow: N,
  tableHeader: R,
  "tableRow-size--s": "_tableRow-size--s_16vn8_103",
  tableColumn: F,
  "tableRow-size--m": "_tableRow-size--m_16vn8_107",
  tableBody: D,
  tableCell: G,
  tableFooter: I,
  "headingText--mobile": "_headingText--mobile_16vn8_132",
  highlight: j,
  showDividers: k,
  "highlight--green": "_highlight--green_16vn8_188",
  "highlight--amber": "_highlight--amber_16vn8_192",
  "highlight--red": "_highlight--red_16vn8_196",
  "mobile-hide": "_mobile-hide_16vn8_200",
  cellWrapper: L,
  headingText: $,
  columnWrapper: E
}, K = ({ children: i, className: t, row: l, ...a }) => /* @__PURE__ */ n("thead", { className: o(e.tableHeader, t), style: { "--gridRow": l }, ...a, children: i }), M = ({ children: i, className: t, ...l }) => /* @__PURE__ */ n("tbody", { className: o(e.tableBody, t), ...l, children: i }), O = ({ children: i, className: t, ...l }) => /* @__PURE__ */ n("tfoot", { className: o(e.tableFooter, t), ...l, children: i }), P = ({ children: i, className: t, size: l = "m", ...a }) => /* @__PURE__ */ n("tr", { className: o(e.tableRow, e[`tableRow-size--${l}`], t), ...a, children: i }), Q = ({ children: i, className: t, ...l }) => /* @__PURE__ */ n("caption", { className: o(e.tableCaption, t), ...l, children: i }), U = ({
  alignItems: i = "center",
  children: t,
  className: l,
  highlight: a,
  justifyContent: c = "flex-start",
  mobileText: s,
  mobileView: x,
  showDividers: h,
  toolTipSide: d,
  tooltipText: r,
  ...m
}) => /* @__PURE__ */ n(
  "th",
  {
    className: o(
      e.tableColumn,
      e[`mobile-${x}`],
      {
        [e.highlight]: a,
        [e.showDividers]: h
      },
      l
    ),
    ...m,
    children: /* @__PURE__ */ b(
      "div",
      {
        className: e.columnWrapper,
        style: {
          "--alignItems": i,
          "--justifyContent": c
        },
        children: [
          s ? /* @__PURE__ */ b(g, { children: [
            /* @__PURE__ */ n("span", { className: e["headingText--mobile"], children: s }),
            /* @__PURE__ */ n("span", { className: e.headingText, children: t })
          ] }) : /* @__PURE__ */ n(g, { children: t }),
          r && /* @__PURE__ */ n(u, { side: d, children: r })
        ]
      }
    )
  }
), X = ({
  alignItems: i = "center",
  children: t,
  className: l,
  highlight: a,
  justifyContent: c = "flex-start",
  showDividers: s,
  style: x,
  ...h
}) => /* @__PURE__ */ n(
  "td",
  {
    className: o(
      e.tableCell,
      {
        [e.highlight]: a,
        [e[`highlight--${a}`]]: a,
        [e.showDividers]: s
      },
      l
    ),
    style: {
      ...x,
      "--alignItems": c,
      "--justifyContent": i
    },
    ...h,
    children: /* @__PURE__ */ n("div", { className: e.cellWrapper, children: t })
  }
), Y = y(({ children: i, className: t, ...l }, a) => /* @__PURE__ */ n("div", { className: e.tableWrapper, "data-cxy-name": "table", children: /* @__PURE__ */ n("table", { className: o(e.table, t), ref: a, ...l, children: i }) })), Z = ({ children: i, className: t, label: l }) => {
  const a = p(), c = _.Children.map(
    i,
    (s) => f(s) ? v(s, {
      "aria-labelledby": a
    }) : s
  );
  return /* @__PURE__ */ b("div", { className: o(e.tableGroup, t), children: [
    l && /* @__PURE__ */ n("h3", { className: e.tableLabel, id: a, children: l }),
    c
  ] });
};
export {
  Y as T,
  M as a,
  Q as b,
  X as c,
  U as d,
  O as e,
  Z as f,
  K as g,
  P as h
};
